/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages

    var break_point = 1088;
    var navname = "main-menu";

    //hamburgers
     $('.hamburger').click(function() {
       $(this).toggleClass('is-active');
     });

    function add_item_span() {
      console.log("add_item_span");
      $(".mobilemenu-container li.menu-item-has-children").each(function() {
        $(this).append('<span class="extract"></span>');
      });
    }

    function expand() {
      console.log("expand");
      $(".mobilemenu-container li.menu-item-has-children span.extract").on(
        "click",
        function() {

          var parentid = $(this).closest('li').attr('id');

          $( "#" + parentid + " .sub-menu" ).slideToggle( "fast", function() {
            // Animation complete.
          });

        }
      );
    }

    function mobile_open_close() {
      console.log("mobile_open_close");
      $("button.hamburger").on("click", function() {
        // $('.mobilemenu-container').removeClass("piilota");
        // $('.mobilemenu-wrap-overlay').removeClass("piilota");

        if ($(this).hasClass("is-active")) {
          $(".mobilemenu-container").toggleClass("piilota");
          $(".mobilemenu-wrap-overlay").toggleClass("piilota");
        } else {
          $(".mobilemenu-container").toggleClass("piilota");
          $(".mobilemenu-wrap-overlay").toggleClass("piilota");
        }
      });

    }

    add_item_span();
    expand();
    mobile_open_close();

    //expandable content
    $('.expand_activator').click(function(){
      var id = $(this).attr('id');
    
      var child = $(this).find('.__expand_button');
    
      child.find('.__expand_minus').toggle();
      child.find('.__expand_plus').toggle();
    
      $( '#expand_content_' + id ).slideToggle( "fast", function() {
        // Animation complete.
      });
    });

    //flickity
    if($(".flickity").length) {
      var elem = document.querySelector('.flickity');
      var flkty = new Flickity( elem, {
          accessibility: true,
          // enable keyboard navigation, pressing left & right keys
          adaptiveHeight: true,
          // set carousel height to the selected slide,
          cellSelector: '.flickity-cell',
          autoPlay: false,
          // advances to the next cell
          // if true, default is 3 seconds
          // or set time between advances in milliseconds
          // i.e. `autoPlay: 1000` will advance every 1 second
          cellAlign: 'center',
          // alignment of cells, 'center', 'left', or 'right'
          // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)
          //cellSelector: undefined,
          // specify selector for cell elements
          contain: false,
          // will contain cells to container
          // so no excess scroll at beginning or end
          // has no effect if wrapAround is enabled
          draggable: '>1',
          // enables dragging & flicking
          // if at least 2 cells
          dragThreshold: 3,
          // number of pixels a user must scroll horizontally to start dragging
          // increase to allow more room for vertical scroll for touch devices
          freeScroll: false,
          // enables content to be freely scrolled and flicked
          // without aligning cells
          friction: 0.2,
          // smaller number = easier to flick farther
          groupCells: 1,
          // group cells together in slides
          initialIndex: 0,
          // zero-based index of the initial selected cell
          lazyLoad: true,
          // enable lazy-loading images
          // set img data-flickity-lazyload="src.jpg"
          // set to number to load images adjacent cells
          percentPosition: true,
          // sets positioning in percent values, rather than pixels
          // Enable if items have percent widths
          // Disable if items have pixel widths, like images
          prevNextButtons: true,
          // creates and enables buttons to click to previous & next cells
          pageDots: false,
          // create and enable page dots
          resize: true,
          // listens to window resize events to adjust size & positions
          rightToLeft: false,
          // enables right-to-left layout
          setGallerySize: true,
          // sets the height of gallery
          // disable if gallery already has height set with CSS
          watchCSS: false,
          // watches the content of :after of the element
          // activates if #element:after { content: 'flickity' }
          wrapAround: true
          // at end of cells, wraps-around to first for infinite scrolling
      });

      // var elem2 = document.querySelector('.flickity-navigation');
      // var flktynav = new Flickity( elem2, {
      //   prevNextButtons: false,
      //   contain: true,
      //   pageDots: false
      // });

  

      $(window).load(function() {
          flkty.resize();
          //flktynav.resize();
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/routes/common.js